var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no"},[_vm._v(" 404 "),_c('el-button',{staticStyle:{"margin-top":"30px"},attrs:{"type":"primary"},on:{"click":_vm.toHome}},[_vm._v("去首页 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }